var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"op-header"},[_c(_setup.GlobalSearch,{staticClass:"op-header__global-search"}),_c('div',{staticClass:"op-header__nav"},[(!_setup.session.isSearchFeed)?_c(_setup.TutorialDropdown):_vm._e(),(_setup.user)?_c(_setup.Avatar,{attrs:{"user":_setup.user},on:{"logout":_setup.logOut}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }